module.exports = __webpack_public_path__ + "img/schoolforlife.088fda3.png";